import application from 'application/application';

application

	.value('masks', {
		date: '00/00/0000',
		hour: '00:00',
		time: '00:00:00',
		dateTime: '00/00/0000 00:00:00',
		CEP: '00000-000',
		UF: {
			mask: 'AA',
			options: {
				translation: {
					A: { pattern: /[A-Za-z]/ }
				}
			}
		},
		telephone: '+55 00 900000000',
		CPF: '000.000.000-00',
		CNPJ: '00.000.000/0000-00',
		CNJ: {
			mask: '0000000-00.0000.0.00.0000',
			options: {
				reverse: true
			}
		},
		currency: {
			mask: '000.000.000.000.000,00',
			options: {
				reverse: true
			}
		}
	});
